export class WrappedId {
    constructor(id) {
        this.id = id;
    }
}